/** @jsx jsx */

import { GatsbyImage } from 'gatsby-plugin-image'
import { Flex, Grid, jsx } from 'theme-ui'
import React from 'react'
import Heading from '~/components/IntlComponents/Heading'
import Text from '~/components/IntlComponents/Text'
import StyledWrapper from '~/components/Generic/StyledWrapper'
import { makeFloatAnimation } from '~/utils/animations'

const NutritionSection = ({
  valuePropHeading,
  valuePropSubheading,
  globalAssetsReference,
}) => {
  const floatAnimObj = (distance, duration) => {
    const float = makeFloatAnimation(distance)
    return {
      animation: `${float} ${duration}ms infinite ease-in-out`,
    }
  }

  return (
    <>
      <Grid
        sx={{
          placeItems: 'center',
          whiteSpace: 'pre-line',
          textAlign: 'center',
          position: 'relative',
          color: ['secondary', 'primary'],
          px: 40,
          pt: [0, 40],
          pb: [30, 120],
        }}
      >
        <Grid
          sx={{
            position: 'absolute',
            zIndex: -1,
            top: 0,
            placeContent: 'center',
            display: ['none', 'initial'],
          }}
        >
          <svg
            width="740"
            height="751"
            viewBox="0 0 740 751"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M719.097 376.491C719.097 364.602 723.064 352.712 729.015 340.823C734.965 324.971 742.899 309.119 738.932 291.285C734.965 275.433 721.081 261.562 709.18 249.673C699.262 241.747 691.328 231.839 685.378 223.913C681.411 214.005 679.427 202.116 679.427 188.245C677.444 170.412 677.444 152.578 665.542 140.689C655.625 126.818 637.773 122.855 621.905 116.91C610.004 112.947 598.103 108.984 588.186 103.04C580.252 97.095 574.301 85.2058 568.351 73.3166C560.417 57.4644 550.499 41.6121 534.631 35.6675C518.763 27.7414 500.911 31.7045 485.043 33.686C471.159 37.6491 457.274 39.6306 447.357 37.6491C437.439 35.6675 427.522 27.7414 417.604 19.8153C403.72 9.90765 387.852 0 370 0C352.148 0 338.264 9.90765 322.396 19.8153C312.478 27.7414 302.561 33.686 292.643 35.6675C282.726 37.6491 268.841 35.6675 256.94 33.686C239.089 31.7045 221.237 27.7414 207.352 35.6675C191.484 45.5752 181.567 59.4459 173.633 75.2981C167.682 87.1873 161.732 97.095 153.798 105.021C143.88 110.966 131.979 114.929 120.078 118.892C102.227 122.855 86.3586 128.799 74.4575 142.67C64.54 154.559 62.5565 172.393 62.5565 190.227C62.5565 204.098 60.573 215.987 56.606 225.894C52.639 235.802 42.7214 243.728 32.8039 251.654C18.9193 263.544 7.01831 275.433 3.05129 293.266C-0.91572 309.119 7.01831 324.971 12.9688 342.805C16.9358 352.712 20.9029 366.583 20.9029 376.491C20.9029 388.38 16.9358 400.269 10.9853 412.158C5.0348 428.011 -2.89923 443.863 1.06779 461.697C5.0348 477.549 18.9193 491.42 30.8204 503.309C40.7379 511.235 48.6719 521.142 54.6225 529.069C60.573 536.995 60.573 550.865 62.5565 562.755C64.54 580.588 64.54 598.422 76.441 610.311C86.3586 624.182 104.21 628.145 120.078 634.09C131.979 638.053 143.88 642.016 153.798 647.96C161.732 653.905 167.682 665.794 173.633 677.683C181.567 693.536 191.484 709.388 207.352 715.332C223.221 723.259 241.072 719.296 256.94 717.314C270.825 715.333 282.726 713.351 292.643 715.332C302.561 717.314 312.478 725.24 322.396 731.185C336.28 741.092 352.148 751 370 751C387.852 751 401.736 741.092 417.604 731.185C427.522 723.259 437.439 717.314 447.357 715.332C457.274 713.351 471.159 715.333 483.06 717.314C500.911 719.296 518.763 723.259 532.648 715.332C548.516 707.406 556.45 691.554 566.367 677.683C572.318 665.794 578.268 655.887 586.202 647.96C594.136 642.016 606.037 638.053 619.922 634.09C635.79 628.145 653.641 624.182 663.559 610.311C673.477 596.441 675.46 578.607 677.443 562.755C677.443 548.884 679.427 536.995 683.394 527.087C687.361 517.179 697.279 509.253 707.196 501.327C721.081 489.438 732.982 477.549 736.949 459.715C740.916 443.863 732.982 428.011 727.031 410.177C723.064 400.269 719.097 388.38 719.097 376.491Z"
              sx={{ fill: 'secondary' }}
            />
          </svg>
        </Grid>

        <StyledWrapper>
          <Heading
            variant="text.h2"
            sx={{
              // width: '75%',
              px: ['0', '25%'],
              textTransform: 'uppercase',
              marginBottom: 30,
              position: 'relative',
              zIndex: 0,
            }}
          >
            {valuePropHeading}
          </Heading>
        </StyledWrapper>

        <StyledWrapper>
          <Text
            sx={{
              position: 'relative',
              zIndex: 0,
              maxWidth: ['100%', '50%'],
              display: 'inline-block',
            }}
          >
            {valuePropSubheading}
          </Text>
        </StyledWrapper>

        {globalAssetsReference && (
          <Flex
            sx={{
              justifyContent: 'center',
              marginTop: 40,
              mx: 'auto',
              width: ['85%', '60%', '50%'],
              maxWidth: '525px',
              gap: 20,
              flexWrap: 'wrap',
            }}
          >
            {globalAssetsReference.valuePropImage.map(imgObj => (
              <div
                key={imgObj.title}
                sx={{
                  flex: ['0 1 calc(50% - 10px)', '0 1 calc(25% - 15px)'],
                  ...floatAnimObj(15, 6000 + Math.random() * 1000),
                }}
              >
                <GatsbyImage
                  image={imgObj.gatsbyImageData}
                  alt={imgObj.title}
                />
                <Text variant="text.eyebrow">{imgObj.title}</Text>
              </div>
            ))}
          </Flex>
        )}
      </Grid>
    </>
  )
}

export default NutritionSection
